import { render, staticRenderFns } from "./Warenkorb.vue?vue&type=template&id=0d20fb0b"
import script from "./Warenkorb.vue?vue&type=script&lang=ts"
export * from "./Warenkorb.vue?vue&type=script&lang=ts"
import style0 from "./Warenkorb.vue?vue&type=style&index=0&id=0d20fb0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports